const CASES_API_URL = 'https://api.casedb.co/cases.php';

const normalizeLimit = (limit, fallback) => {
    const parsed = Number(limit);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return fallback;
    }
    return Math.min(parsed, 50);
};

const normalizeItem = (item, fallbackType) => ({
    ...item,
    type: item.type || fallbackType,
    value: item.value,
    id: item.value,
    label: item.label || item.case_name || item.contact_name || `${fallbackType === 'case' ? 'Case' : 'Lead'} ${item.value}`,
    contactName: item.contact_name || item.label || '',
    updatedDate: item.updated_at || item.updatedDate || null,
    createdDate: item.created_date || item.createdDate || null,
    phase: item.phase || item.phase_name || null,
    status: item.status || item.status_name || null,
    isOnTeam: Boolean(item.is_on_team ?? item.isOnTeam ?? false)
});

export const getNavSearchType = (type = 'both') => {
    if (type === 'cases' || type === 'case') return 'cases';
    if (type === 'leads' || type === 'lead') return 'leads';
    return 'both';
};

export const fetchNavSearchResults = async (query = '', { type = 'both', limit = 10, signal } = {}) => {
    const params = new URLSearchParams({
        nav_search: '1',
        type: getNavSearchType(type),
        limit: String(normalizeLimit(limit, 10))
    });

    const trimmedQuery = String(query ?? '').trim();
    if (trimmedQuery !== '') {
        params.set('q', trimmedQuery);
    }

    const response = await fetch(`${CASES_API_URL}?${params.toString()}`, {
        credentials: 'include',
        signal
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
        throw new Error(data?.message || 'Failed to search cases and leads');
    }

    const cases = (data.cases || []).map(item => normalizeItem(item, 'case'));
    const leads = (data.leads || []).map(item => normalizeItem(item, 'lead'));

    return {
        cases,
        leads,
        combined: [...cases, ...leads]
    };
};

export const toCaseLeadSelectionOptions = (results) => {
    return (results?.combined || []).map(item => ({
        ...item,
        value: `${item.type}_${item.value}`,
        label: `${item.label} (${item.type})`
    }));
};

export const toCaseSelectionOptions = (results) => {
    return (results?.cases || []).map(item => ({
        ...item,
        value: String(item.value),
        label: item.label
    }));
};

export const parseCaseLeadSelection = (value) => {
    if (!value || typeof value !== 'string') {
        return null;
    }

    const [type, rawId] = value.split('_');
    if (!type || !rawId) {
        return null;
    }

    const id = Number(rawId);
    if (!Number.isFinite(id)) {
        return null;
    }

    return {
        type,
        id
    };
};